import { format } from 'date-fns';

// dd/mm/aa (ej. 27/09/26). Devuelve '' si no hay fecha o no es válida. Usado en las tablas de solicitudes.
export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

// dd/MM/yyyy (ej. 27/09/2026). Usado en los checklists.
export const formatDate = (dateString) => format(new Date(dateString), 'dd/MM/yyyy');

// HH:mm (ej. 17:00). Usado en los checklists.
export const formatTime = (dateTimeString) => format(new Date(dateTimeString), 'HH:mm');
